<template>
  <div class="aspect-ratio-container">
    <div v-html="customStyleHtml"/>
    <div :style="computedScalerStyle" class="aspect-ratio-container-scaler">
      <div :style="computedAppStyle" class="aspect-ratio-container-app">
        <slot/>

        <div :style="computedNegateStyle" class="aspect-ratio-container-negate">
          <slot name="negate"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AspectRatioContainer',
  props: {
    aspectWidth: {
      type: Number,
    },
    aspectHeight: {
      type: Number,
    },
  },
  data() {
    return {
      scale: 100,

      scaleW: 100,
      scaleH: 100,

      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
    }
  },
  watch: {
    scale() {
      this.updateStoreScale();
    },
  },
  mounted() {
    window.addEventListener('resize', this.onResize);

    this.onResize();

    this.updateStoreScale();
  },
  unmounted() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    updateStoreScale() {
      this.$store.commit('aspectRatioScale', this.scale);
      this.$store.commit('aspectRatioScaleW', this.scaleW);
      this.$store.commit('aspectRatioScaleH', this.scaleH);
      this.$store.commit('aspectRatio', this.scaleW / this.scaleH);

      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;

      this.$store.commit('aspectRatioWindow', windowWidth / windowHeight);
    },
    onResize() {
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;

      const currentCalculatedAspectRatioWH = windowWidth / windowHeight;

      this.windowWidth = windowWidth;
      this.windowHeight = windowHeight;

      if (currentCalculatedAspectRatioWH > this.aspectRatioWH) {
        // Black bars on top and bottom
        this.scale = (windowHeight / this.aspectHeight);

        this.scaleW = this.scale;
        this.scaleH = 1;
      } else {
        // Black bars on side
        this.scale = (windowWidth / this.aspectWidth);

        this.scaleW = 1;
        this.scaleH = this.scale;
      }
    },
  },
  computed: {
    customStyleHtml() {
      const fullWidthPx = Math.ceil(this.windowWidth / this.scale);
      const fullHeightPx = Math.ceil(this.windowHeight / this.scale);

      const fullWidthOffsetPx = (fullWidthPx - this.aspectWidth) * -0.5;
      const fullHeightOffsetPx = (fullHeightPx - this.aspectHeight) * -0.5;

      const resetWidthPx = Math.ceil(fullWidthPx * this.scale);
      const resetHeightPx = Math.ceil(fullHeightPx * this.scale);

      const resetWidthOffsetPx = 0;
      const resetHeightOffsetPx = 0;

      /*console.log({
          fullWidthPx,
          fullHeightPx,

          fullWidthOffsetPx,
          fullHeightOffsetPx,

          resetWidthPx,
          resetHeightPx,

          resetWidthOffsetPx,
          resetHeightOffsetPx,

          scaleW: this.scaleW,
          scaleH: this.scaleH,
      });*/

      const css = `
            .ar-full {
            	width: ${fullWidthPx}px !important;
            	height: ${fullHeightPx}px !important;
            	left: ${fullWidthOffsetPx}px !important;
            	top: ${fullHeightOffsetPx}px !important;
            }
            `;

      /*.ar-negate-reset {
          width: ${resetWidthPx}px;
          height: ${resetHeightPx}px;
          transform: translate(${resetWidthOffsetPx}, ${resetHeightOffsetPx});
      }*/

      return `<style>${css}</style>`;
    },
    computedNegateStyle() {
      const negateScale = 1 - this.scale;

      const offsetX = (this.aspectWidth / negateScale) / 2;
      const offsetY = (this.aspectHeight / negateScale) / 2;

      return {
        'transform': `scale(${negateScale}) translate(${offsetX}px, ${offsetY}px)`,
      }
    },
    computedAppStyle() {
      return {
        'width': this.aspectWidth + 'px',
        'height': this.aspectHeight + 'px',
      }
    },
    computedScalerStyle() {
      const offsetX = (this.aspectWidth / this.scale) / 2;
      const offsetY = (this.aspectHeight / this.scale) / 2;

      return {
        'transform': `scale(${this.scale}) translate(-${offsetX}px, -${offsetY}px)`,
      }
    },
    aspectRatioWH() {
      return this.aspectWidth / this.aspectHeight;
    },
  }
}
</script>

<style lang="scss" scoped>
.aspect-ratio-container {
  width: 100%;
  height: 100%;
}

.aspect-ratio-container-scaler {
  position: absolute;
  top: 50%;
  left: 50%;
}
</style>
